<template>
  <el-dialog
    :title="typeTitle === 'add' ? '新增问卷' : '修改问卷'"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="formRef"
      :model="form"
      :rules="surveyRules"
      label-width="110px"
    >
      <el-form-item label="问卷名称版本" prop="title">
        <el-input v-model="form.title" placeholder="请输入问卷名称版本"></el-input>
      </el-form-item>
      <el-form-item label="生效范围" prop="communityUuid">
          <el-select v-model="form.communityUuid" placeholder="请选择小区" filterable clearable style="width: 100%">
              <el-option v-for="item in communityList" :key="item.uuid" :label="item.name" :value="item.uuid"/>
          </el-select>
      </el-form-item>
      <el-form-item v-if="typeTitle === 'edit'" label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="801201">生效</el-radio>
          <el-radio :label="801202">停用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.comment" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { getCommunityListApi,} from "@/api/publish";
  import {addFeedbackApi} from "@/api/online-survey";
  import {MessageSuccess} from "@custom/message";
  // import { updateAticity } from "@/api/";
export default {
      name: "layer-survey-dialog",
      data() {
        return {
            dialogVisible: false,
            typeTitle:"add",
            form:{
              title:"",
              communityUuid:"",
              status:801201,
              comment:"",
            },
            surveyRules: {
              title: [{ required: true, message: '请输入问卷名称版本', trigger: 'blur' }],
              communityUuid: [{ required: true, message: '请选择生效范围', trigger: 'change' }],
              status: [{ required: true, message: '请选择状态', trigger: 'change' }]
            },
            communityList: [],
        }
    },
  props: {
    scopeOptions: { type: Array, default: () => [] }
  },
  computed: {
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.form ={title:"",communityUuid:"",status:801201,comment:"",}
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          const {title,communityUuid,status,comment, }= this.form
          let params = {
            title,communityUuid,status,comment,
            nodeType:801251,//标题
          }
          const loading = this.$loading({lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
          addFeedbackApi(params).then(res => {
              MessageSuccess('添加成功');
              this.handleClose();
              this.$emit('handleSearch');
          }).finally(() => loading.close());
        }
      })
    },
        async openDialog(type) {
            const that = this;
            this.typeTitle = type;
            that.dialogVisible = true;
        },    
  },
  mounted() {
      getCommunityListApi().then(res => {
          this.communityList = res.list;
       });
  },
}
</script>
